import Axios from '../axios'
import { getHeadersWithJwtToken } from 'auth/utils/auth-util'
import { logError } from 'shared'
import appConfig from 'app.config'

async function GetReferalLinkFriendsService(country: string) {
	const { data } = await Axios.get(
		`${appConfig.customerDataBaseUrl}/api/ReferralLink/friends?country=${country}`,
		await getHeadersWithJwtToken()
	)
		.then((res) => {
			return res
		})
		.catch((err) => {
			console.log(err.response)
			logError(err)
			return err.response
		})
	return data
}

export default GetReferalLinkFriendsService
